import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, onMounted, computed } from 'vue';
import { NotificationType } from '@/types/game.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    message: {},
    type: {},
    duration: {}
  },
  emits: ['dismiss'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const show = ref(true);

onMounted(() => {
  setTimeout(() => {
    show.value = false;
    emits('dismiss');
  }, props.duration || 3000); // 3000 ms par défaut
});

const notificationClass = computed(() => {
  switch (props.type) {
    case 'success':
      return 'bg-green-500';
    case 'error':
      return 'bg-red-500';
    case 'info':
      return 'bg-blue-500';
    default:
      return 'bg-white';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (show.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["notification p-4 text-center text-white rounded shadow-lg", notificationClass.value])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})